// extracted by mini-css-extract-plugin
export default {"input":"FieldCurrencyInput_input__ivvM6","inputSuccess":"FieldCurrencyInput_inputSuccess__4PVLQ","inputError":"FieldCurrencyInput_inputError__hd6KT"};